module.exports = __webpack_public_path__ + "static/media/icon_zhuanye.cbbfbb59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageSecAwarenrssSolution/icon_zhuanye.svg
// module id = 234
// module chunks = 0